import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Button } from "./ui/button";
import { Reveal, Overline } from "./Reveal";
import { PRODUCTS } from "../lib/data";

export default function Products() {
  return (
    <section id="products" data-testid="products" className="relative py-12 md:py-16 noise border-t border-line">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>Our products</Overline>
          <div className="mt-4 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight max-w-2xl leading-tight">
                Product-led solutions for billing and real estate operations.
              </h2>
              <p className="mt-6 text-textsub max-w-xl leading-relaxed">
                Built for small businesses and enterprise teams that need faster billing, GST compliance and intelligent real estate workflows with modern communication integrations.
              </p>
            </div>
            <a href="#contact" className="inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-[#05050A] hover:bg-brand/90 transition-colors">
              Get in touch for details <ArrowUpRight size={16} />
            </a>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {PRODUCTS.map((product, i) => (
            <Reveal key={product.id} delay={i * 0.08}>
              <div className="rounded-[2rem] glass p-6 h-full border border-transparent hover:border-brand/40 transition-all duration-300">
                <p className="text-xs font-mono uppercase tracking-[0.2em] text-brand">{product.tagline}</p>
                <h3 className="mt-4 font-heading text-3xl font-semibold tracking-tight">{product.title}</h3>
                <p className="mt-4 text-sm text-textsub leading-relaxed">{product.desc}</p>

                <ul className="mt-6 space-y-3">
                  {product.points.map((point) => (
                    <li key={point} className="flex items-start gap-3 text-sm text-textmain">
                      <span className="mt-1 h-2.5 w-2.5 rounded-full bg-brand" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-6 flex items-center gap-3 flex-wrap">
                  <a href="#contact" className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brand/90 transition-colors">
                    Get in touch <ArrowUpRight size={14} />
                  </a>
                  <Button asChild variant="secondary" size="lg">
                    <a href="#contact">Request a demo</a>
                  </Button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
